import { planDelCatalogo } from './planAccess';
import { eurosRedondos } from './precios';

// QUÉ PLANES SE LE OFRECEN A QUIÉN EN LOS DESPLEGABLES DEL EQUIPO (Francisco, 12-10: "los
// planes antiguos son solo para clientes antiguos; los nuevos con los planes nuevos").
//
// La regla la decide el servidor (`backend/core/plan_que_se_puede_poner.py`) y viaja en el
// catálogo de `GET /plans`: `para_nuevos` (con ese plan entra un cliente nuevo) y
// `para_quien_tiene_plan` (se le puede poner a quien ya tiene otro: los nuevos más
// Mantenimiento, que es la salida). Aquí solo se ordena para pintarlo: los planes que se
// pueden elegir y, aparte, el suyo si es un plan antiguo, para que guardar la ficha no se
// lo quite. Ningún otro plan antiguo sale en la lista.
export function planesParaElegir(catalogo, planActual) {
    const actual = String(planActual || '').trim();
    const campo = actual ? 'para_quien_tiene_plan' : 'para_nuevos';
    const nuevos = Object.entries(catalogo || {})
        .filter(([, p]) => p && p[campo])
        .map(([code, p]) => ({ code, name: p.name }));
    const loTieneYa = !actual || nuevos.some(p => p.code === actual);
    const suyo = loTieneYa ? null : { code: actual, name: planDelCatalogo(catalogo, actual)?.name || actual };
    return { nuevos, suyo };
}

// LOS PLANES DEL ENLACE DE PAGO DE UN LEAD (12-10, revisión). Estaban escritos a mano en el
// panel, con el precio dentro (897, 497, 197), y no ofrecían El Lunes Empiezo, que el
// servidor sí cobra. Salen del catálogo: los planes con los que entra un cliente nuevo, con
// su precio. Y si el lead es la RENOVACIÓN POR LLAMADA de un cliente (`renueva_por_llamada`,
// que lo dice el servidor), su plan entra aunque sea antiguo y viene elegido: es el que
// pidió, y se cobra a su precio, que no es el del catálogo (por eso va sin importe).
// Sin renovación viene elegido el que le recomendó el test, y si no el primero de la lista.
export function planesDelEnlaceDePago(catalogo, lead) {
    const opciones = planesParaElegir(catalogo, null).nuevos.map(({ code, name }) => {
        const precio = Number(catalogo?.[code]?.precio);
        return { code, label: precio > 0 ? `${name} · ${eurosRedondos(precio)}` : name };
    });
    const renueva = lead?.renueva_por_llamada?.plan || null;
    if (renueva) {
        const nombre = lead.renueva_por_llamada.nombre || planDelCatalogo(catalogo, renueva)?.name || renueva;
        const suya = { code: renueva, label: `${nombre} · su renovación` };
        const sinEse = opciones.filter(p => p.code !== renueva);
        return { opciones: [suya, ...sinEse], porDefecto: renueva };
    }
    const recomendado = opciones.find(p => p.code === lead?.recomendado)?.code;
    return { opciones, porDefecto: recomendado || opciones[0]?.code || '' };
}
